import { formatMinutesToHoursAndMinutes } from '../../utils/helper';

export const getFormattedTimeValues = (
  data: {
    uninterruptedTime: number;
    totalTimeInGameArea: number;
    totalTimeOutsideGameArea: number;
  },
  t: (key: string) => string,
) => ({
  currentUninterruptedTime:
    formatMinutesToHoursAndMinutes(data.uninterruptedTime) +
    ` - ${t('createHarmReport.ongoing')}`,
  totalTimeInGambling: formatMinutesToHoursAndMinutes(data.totalTimeInGameArea),
  totalTimeOutside: formatMinutesToHoursAndMinutes(
    data.totalTimeOutsideGameArea,
  ),
});

export const timeStringToMinutes = (time: string): number => {
  const hourMatch = time.match(/(\d+)h/);
  const minuteMatch = time.match(/(\d+)m/);

  const hours = hourMatch ? parseInt(hourMatch[1], 10) : 0;
  const minutes = minuteMatch ? parseInt(minuteMatch[1], 10) : 0;

  return hours * 60 + minutes;
};

export const decimalToOrdinal = (n: number): string => {
  const lastTwo = n % 100;
  if (lastTwo >= 11 && lastTwo <= 13) return `${n}th`;

  switch (n % 10) {
    case 1:
      return `${n}st`;
    case 2:
      return `${n}nd`;
    case 3:
      return `${n}rd`;
    default:
      return `${n}th`;
  }
};

export const isAutoGeneratedReport = (
  report: { identifiedBy?: { type?: string } } | null,
): boolean => report?.identifiedBy?.type === 'System';
